import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { Usuario } from '../interfaces/book.interface';
import { AuthService } from '../services/auth.service';
import { FirebaseService } from '../services/firebase.service';

@Injectable()

export class AuthFalseGuard implements CanActivate, OnDestroy {

  private subscription: Subscription = new Subscription();
  
  userData: Usuario = {
    rol: null,
    // cc: null,
    nombre: '',
    email: '',
    celular: '',
    // nacimiento: null,
    ciudad: null,
    // sexo: null,
  };

  constructor(
    private firebase: FirebaseService,
    private auth: AuthService,
    public navCtrl: NavController
  ) { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   
    return new Promise(async (resolve, reject) => {
      this.auth.getUidState().subscribe(user => {
        if (user) {
          const uid = user.uid;
          console.log('User Auth id ->', uid);
          const path = '/usuarios/' + user.uid;
          this.subscription.add(
            this.firebase.getDoc<Usuario>(path).subscribe(async data => {
              console.log('User Auth data->', data);
              this.userData = data;
              resolve(false);
              this.redirectAcces(this.userData.rol);
            })
          );
        } else {
          resolve(true);
        }
      })
    });

  }

  redirectAcces(rol: string) {
    this.auth.isLogin().then(async (userLogin: any) => {
      console.log('User Auth ->', userLogin);
      if (userLogin) {
        if (!userLogin.emailVerified) {
          this.navCtrl?.navigateRoot('/verify-email');
        } else {
          if (rol == 'root') { // ROT
            this.navCtrl?.navigateRoot('/root-dashboard');
          } else if (rol == 'admin') { // ADMIN
            this.navCtrl?.navigateRoot('/admin-dashboard');
          } else if (rol == 'propietario') { // PROPIETARIO
            this.navCtrl?.navigateRoot('/propietario-dashboard');
          } else if (rol == 'transportador') { // TRANSPORTADOR
            this.navCtrl?.navigateRoot('/transportador-dashboard');
          } else if (rol == 'comercio') { // COMERCIO
            this.navCtrl?.navigateRoot('/comercio-dashboard');
          } else if (rol == 'cliente') { // CLIENTE
            this.navCtrl?.navigateRoot('/cliente-encarga');
          } else {
            this.navCtrl?.navigateRoot('/logout');
          }
        }
      } else {
        this.navCtrl?.navigateRoot('/login');
      }
    })

  }

}
